export var TagOnceSettingsProperties;
(function (TagOnceSettingsProperties) {
    TagOnceSettingsProperties["DELAY_ATTACH_RESOURCE_MS"] = "delayAttachResourceMs";
})(TagOnceSettingsProperties || (TagOnceSettingsProperties = {}));
